var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.cssClass,attrs:{"type":_vm.type,"disabled":_vm.loading},on:{"click":_vm.click}},[(_vm.loading)?[_c('Loader',{staticStyle:{"height":"25px"},attrs:{"size":"20"}})]:_vm._e(),(!_vm.loading)?[_vm._v(" "+_vm._s(_vm.phrase)+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }